import { render, staticRenderFns } from "./resultsDisplay2.vue?vue&type=template&id=24ab7193"
import script from "./resultsDisplay2.vue?vue&type=script&lang=js"
export * from "./resultsDisplay2.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports